import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// INITIAL STATE
const initialState = {
  input: {
    emailAddress: null,
  },
  pending: false,
  fulfilled: false,
  rejected: false,
  success: false,
  error: null,
};

const __error__ = {
  errorCode: null,
  captcha: true,
};

// CREATE ACTION
export const validateEmailAddressAction = createAsyncThunk(
  "emailAddress/validate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      let response = await axios.post(
        `${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/integrations/auth/captcha/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.data.success === true) {
        // validate email address
        response = await axios.post(
          `${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/users/me/integrations/evolt/email-address`, // apigee
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${payload.token}`,
            },
          }
        );

        return response.data;
      } else {
        __error__.errorCode = response.data.data["error-codes"][0];
        throw __error__;
      }
    } catch (error) {
      if (error.captcha) return rejectWithValue(error.errorCode);
      else {
        const errorResponse = error.response;
        if (
          errorResponse &&
          errorResponse.data &&
          errorResponse.data.LFconnect &&
          errorResponse.data.exception &&
          errorResponse.data.exception.innerErrors &&
          errorResponse.data.exception.innerErrors.length > 0
        )
          return rejectWithValue(
            errorResponse.data.exception.innerErrors[0].target
          );
        else
          return rejectWithValue(
            `${error.message} - Please contact System Administrator.`
          );
      }
    }
  }
);

// CREATE SLICE
const connectEvolSlice = createSlice({
  name: "Evolt",
  initialState,
  extraReducers: (builder) => {
    //update account
    builder.addCase(validateEmailAddressAction.pending, (state, action) => {
      state.pending = true;
      state.fulfilled = false;
      state.rejected = false;
      state.error = null;
    });
    builder.addCase(validateEmailAddressAction.fulfilled, (state, action) => {
      state.pending = false;
      state.fulfilled = true;
      state.input = {
        emailAddress: action.payload.emailAddress,
      };
      state.rejected = false;
      state.error = null;
    });
    builder.addCase(validateEmailAddressAction.rejected, (state, action) => {
      state.pending = false;
      state.fulfilled = false;
      state.rejected = true;
      state.error = action.payload;
      state.input = {
        emailAddress: null,
      };
    });
  },
});

// CREATE REDUCER
const connectEvoltReducer = connectEvolSlice.reducer;
export default connectEvoltReducer;
